module.exports = __webpack_public_path__ + "img/logo.fb48e5cc.png";